<template>
  <div v-show="profile" class="profile-list-item">
    <div class="profile-list-item-label">
      <h5 class="profile-list-item-label-top">
        {{ topLabel }}
      </h5>
      <h3 class="profile-list-item-label-middle">
        {{ middleLabel }}
      </h3>
      <grade-variation-chip
        v-if="bottomLabel"
        :variation="bottomLabel"
        no-color
      />
    </div>

    <div class="profile-list-item-right">
      <span v-if="!profile.hasMatches && profile.graderList && profile.graderList.length > 0" class="profile-list-item-grader">
        <span v-if="graderLogoSrc" class="profile-list-item-grader-pill">
          <img
            class="profile-list-item-grader-img"
            :src="graderLogoSrc"
            :alt="primaryGraderLabel"
          />
        </span>
        <pill v-else>
          {{ primaryGraderLabel }}
        </pill>
      </span>

      <icon v-else name="playlist_add_check" />

      <stat-item
        label="Total Population"
        :value="$filters.number(profile.totalPopulation)"
      />
    </div>
  </div>
</template>

<script>
import GradeVariationChip from '@cardladder/shared/components/GradeVariationChip';
import StatItem from '@cardladder/shared/components/StatItem';

import { graderLogoSrc as resolveGraderLogo } from '@/utils/graderLogos';

export default {
  components: {
    GradeVariationChip,
    StatItem,
  },
  props: {
    profile: Object,
  },

  computed: {
    primaryGrader() {
      return (this.profile.graderList && this.profile.graderList[0]) || '';
    },

    primaryGraderLabel() {
      return String(this.primaryGrader).toUpperCase();
    },

    graderLogoSrc() {
      return resolveGraderLogo(this.primaryGrader);
    },

    topLabel() {
      return `${this.profile.year} ${this.profile.set}`.trim();
    },

    middleLabel() {
      return `${this.profile.subject} ${this.profile.number ? `#${this.profile.number}` : ''}`.trim();
    },

    bottomLabel() {
      if (!this.profile.variation) return null;
      return `${this.profile.variation}`.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-list-item {
  padding: $gp;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $gp;

  --pill-margin: 0;
  --icon-size: 32px;

  i {
    color: $color-green-1;
  }
}

.profile-list-item-label-top {
  font-size: 16px;
  margin: 0;
}

.profile-list-item-label-middle {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
}

.profile-list-item-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: $gp;
  justify-content: space-between;
  --stat-item-justify: flex-end;
}

.profile-list-item-grader-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  border: 2px solid var(--theme-border);
}

.profile-list-item-grader-img {
  display: block;
  max-height: 22px;
  width: auto;
  max-width: 50px;
  object-fit: contain;
}
</style>
